// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"446":"e25da13f","787":"57cd1f6f"}[chunkId] + ".chunk.js";
};